import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { setDeleteCollaborator, removeCollaborator } from 'project/ducks/collaborators';

export function mapStateToProps({ project: { collaborators } }) {
  const { remove } = collaborators.data;
  const email = remove ? remove.user.email : '';
  const msg = `If you remove them from your project, ${email} will be prevented from working on this project.`;

  return {
    dialogVisible: !!remove,
    dialogHeader: `Are you sure you want to remove ${email}?`,
    dialogMessage: msg,
  };
}

export function mapDispatchToProps(dispatch, { projectId }) {
  return bindActionCreators({
    toggleDialog: partial(setDeleteCollaborator, null),
    submitAction: partial(removeCollaborator, projectId),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./project/containers/remove_collaborator.js